<template>
  <div class="mt-6">
    <v-dialog v-model="AccessCodeFlag" persistent max-width="600px">
      <v-card>
        <v-card-title class="flex justify-center">
           {{$t("labels.CliMortgageProtection")}}
        </v-card-title>
        <v-card-text>
          <v-container>           
            <v-card-text >
              <p style="display:flex" class="justify-center">{{ $t("labels.CliApplicationVerificationCode") }}</p>
               <v-alert type="error" v-show="showErrorAlert" outlined>{{
                  errorMessage
                }}</v-alert>
                <div
                  class="d-flex"
                  style="margin-top: 15px; margin-bottom: 15px"
                >
                  <com_six ref="sixdigit" v-model="validateCode" />
                </div>
            </v-card-text>  
            <v-card-text>
              <p style="display:flex" class="justify-center">Didn't get the code? <span @click="resendEmailFunction" style="margin-left:2px" class="bLink">Resend</span></p>
            </v-card-text>                 
          </v-container>
        </v-card-text>
         <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn  color="blue darken-1" :disabled="validateCode == null" text @click="submit()">{{$t('labels.Submit')}}</v-btn>
          <v-btn  color="blue darken-1" text @click="clearField()">{{$t('labels.Clear')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-container>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card>
            <v-card-title >{{
              $t("labels.CliMortgageProtection")
            }}</v-card-title>
          </v-card>
          <v-card class="mt-2">
            <v-card-text>
              <p>{{ $t("labels.CliApplicationVerificationCode") }}</p>
              <v-form ref="form">
                <v-alert type="error" v-show="showErrorAlert" outlined>{{
                  errorMessage
                }}</v-alert>
                <div class="d-flex" style="margin-top: 15px; margin-bottom:15px;">
                  <com_six ref="sixdigit" v-model="validateCode" />
                </div>               
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn dark color="primary" @click="submit()">{{
                    $t("labels.CLI_Continue")
                  }}</v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container> -->
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>
<script>
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import uiSvc from "@/services/uiService";
import domainHelper from "@/services/domainHelper";
import money from "v-money";
import com_six from "@/shared/components/sixDigit";
export default {
  components: { com_six },
  data() {
    return {
      AccessCodeFlag: true,
      validateCode: null,
      menu: false,
      loadFlag: false,
      showErrorAlert: false,
      errorMessage: "",
      siteID: this.$route.params.siteid,
      token: this.$route.params.token,
      disableSubmit: false,
      securityQuestion: {
        loanAmount: 0,
        postalCode: null,
        dateOfBirth: null,
      },
      currency_config: {
        decimal: ".",
        thousands: ",",
        prefix: "R$ ",
        precision: 2,
        masked: false,
        allowBlank: true,
        default: null,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER,
      },
      currencyRequired: [
        (v) => !!v || "",
        (v) => this.securityQuestion.loanAmount > 0 || "",
      ],
      postalCodeRequired: [(v) => !!v || ""],
      dateOfBirthRequired: [(v) => !!v || ""],
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    //   securityQuestion:function(){
    //      this.disableSubmit = !(this.securityQuestion.loanNumber
    //                         && this.securityQuestion.loanAmount
    //                         && this.securityQuestion.postalCode
    //                         && this.securityQuestion.dateOfBirth);
    //   }
  },
  methods: {
    resendEmailFunction(){
        var accesscodeLinkUrl =
        domainHelper.getAPIHost() + "/cli-api/send-accesscode";
      var postData = {
        siteId: this.siteID,
        token: this.token,    
        languageId: localStorageSvc.getLan(),   
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post(accesscodeLinkUrl, postData)
        .then((res) => {
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.loadFlag = false;
            this.$alert(
              this.$t("Success"),
              "Access Code successfully sent"
            );  
          } else {
            this.loadFlag = false;
            this.errorMessage = this.$t(
              "errors." + res.data.ReturnStatus.ReturnMessage
            );
            this.showErrorAlert = true;
          }
        })
        .catch((err) => {
          this.loadFlag = false;
          uiSvc.alertError(err);
        });
    },
    clearField(){
      this.showErrorAlert = false;
      this.validateCode = null;
      this.$refs.sixdigit.Verifyclear();
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    submit() {
    //   if (!this.$refs.form.validate()) {
    //     return;
    //   }
      var validateLinkUrl =
        domainHelper.getAPIHost() + "/cli-api/validate-token";
      var postData = {
        siteId: this.siteID,
        token: this.token,
        securityQuestion: this.securityQuestion,
        languageId: localStorageSvc.getLan(),
        Code: this.validateCode
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post(validateLinkUrl, postData)
        .then((res) => {
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.loadFlag = false;
            var applicationListPath =
              "/" +
              this.siteID +
              "/cli/application/" +
              res.data.Token +
              "/form";
            this.$router.push({ path: applicationListPath });
          } else {
            this.loadFlag = false;
            this.errorMessage = this.$t(
              "errors." + res.data.ReturnStatus.ReturnMessage
            );
            this.showErrorAlert = true;
          }
        })
        .catch((err) => {
          this.loadFlag = false;
          uiSvc.alertError(err);
        });
    },
  },
};
</script>
<style scoped>
</style>